import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('PollVars')
export class PollVars {
  @JsonProperty('authType', String, true)
  authType: string = undefined;
  @JsonProperty('headerLogo', String, true)
  headerLogo: string = undefined;
  @JsonProperty('footerLogo', String, true)
  footerLogo: string = undefined;
  @JsonProperty('idTemplate', Number, true)
  idTemplate: number = undefined;
}
